// Solutions.js
import React from 'react';
import './Pages.css';
import raAnalytics from '../assets/images/riskadjustments-analytics_thumb.png';
import arrowDirRight from '../assets/images/arrow-right-circled.svg';

function Solutions() {
  return (
    <section id="services" className='has-fixed-header py-5 pb-0'>
    <div className='container-fluid p-0 ps-0'>
      <div className="container">
        <div className="row align-items-star">
          <div className="col-md-12 col-sm-12">
              <div className='content-section'>
              <h1 className="display-6 text-primary">Our Solutions</h1>
                <p className="col-md-12 col-sm-12 mx-auto lead text-black">
                  Elevate offers a comprehensive range of services tailored to meet the unique challenges of risk adjustment in the healthcare industry. <br/>Explore how we can help your organization succeed.
                </p>
              </div>
          </div>
        </div>

        <div className='section-solutions'>
        <div className='row h-100 py-2 align-items-center justify-content-center'>

<div className='col-xs-12 col-sm-12 col-md-12 col-lg-4'>
          <h3 className='display-5 text-primary m-0'>
          Comprehensive<br/>
          Risk Adjustment<br/>
          Solutions
          </h3>
          <p className='text-black mt-2'>
          Tailored for payers and providers to maximize accuracy and efficiency.
          </p>
</div>

<div className='col-xs-12 col-sm-12 col-md-12 col-lg-8'>
    <ul className='solutions-list__cards'>
      <li className='solutions-list__card col-lg-4 col-md-4 col-xs-12 col-sm-12 theme-primary'>
        <div className='card-body'>
          <img src={raAnalytics} alt='risk adjustment analytics' className='img-fluid' />
        </div>
        <div className='card-footer'>
          <a href='' className='card-footer__nav'>
            <span className='nav-title'>Risk Adjustment<br/>Analytics</span>
            <img src={arrowDirRight} alt='arrow direction right' className='img-fluid arrow-direction' />
          </a>
        </div>
      </li>

      <li className='solutions-list__card col-md-4 col-xs-12 col-sm-12 theme-secondary'>
      <div className='card-body'>
          <img src={raAnalytics} alt='risk adjustment analytics' className='img-fluid' />
        </div>
        <div className='card-footer'>
          <a href='' className='card-footer__nav'>
          <span className='nav-title'>NLP-Driven Medical<br/>Coding</span>
            <img src={arrowDirRight} alt='arrow direction right' className='img-fluid arrow-direction' />
          </a>
        </div>
      </li>

      <li className='solutions-list__card col-md-4 col-xs-12 col-sm-12 theme-quaternary'>
      <div className='card-body'>
          <img src={raAnalytics} alt='risk adjustment analytics' className='img-fluid' />
        </div>
        <div className='card-footer'>
          <a href='' className='card-footer__nav'>
          <span className='nav-title'>Audit and Compliance<br/>Support</span>
          <img src={arrowDirRight} alt='arrow direction right' className='img-fluid arrow-direction' />
          </a>
        </div>
      </li>
    </ul>
</div>

</div>
        </div>

    </div>
  </div>



    </section>
  );
}

export default Solutions;